import { DiscountLabelHandler } from '../shared/above-the-fold/discount-label-handler';
import { DropdownVariantHandler } from './dropdown-variant-hander';
import PriceHandler from '../shared/above-the-fold/price-handlers/variant-price-handler';
import ButtonHandler from '../shared/product/button-handler';
import OutOfStockHandler from '../shared/product/out-of-stock-handler';

export default class VariantSelectDropdown extends DropdownVariantHandler {
  handlers = [
    new ButtonHandler(),
    new PriceHandler(),
    new OutOfStockHandler(),
    new DiscountLabelHandler()
  ];
}
